konnyScript(function($){
  

  var eventPrdSlide = new Swiper("#knEprd_swiper_slide1", {
      slidesPerView: 'auto',
      slidesPerGroup: 1,
      spaceBetween: '2.9%',
      scrollbar: {
          el:'#knEprd_swiper_slide1 .swiper-scrollbar',
      },
      pagination: {
          el:'#knEprd_swiper_slide1 .swiper-pagination',
      },
  });
  
  //Tab Scroll
  (function () {
    const $tabs = $('.eNavWrap li');
    const sections = [...Array(3)].map((_, i) => $('#eCon' + (i + 1)));
    const isMobile = () => $(window).width() <= 750;

    let isFromClick = false;
    let clickTimeout;

    $('.eNavWrap li a').on('click', function (e) {
      e.preventDefault();
      const $li = $(this).closest('li');
      const index = $li.index();

      clearTimeout(clickTimeout);
      isFromClick = true;
      clickTimeout = setTimeout(() => { isFromClick = false; }, 600);

      $li.addClass('on').siblings().removeClass('on');
      $('.eNavWrap').addClass('fixed');

      const headerHeight = $('#header').outerHeight() || 0;
      const navHeight = $('.eNavWrap').outerHeight() || 0;
      const fixHeight = headerHeight + navHeight;
      const targetSection = $('#eCon' + (index + 1));

      if (targetSection.length) {
        const targetTop = targetSection.offset().top - fixHeight - navHeight;
    
        if (window.scrollY === 0) {
          $('.eNavWrap').addClass('fixed');
    
          window.scrollTo({ top: 1 });
          setTimeout(() => {
            window.scrollTo({ top: targetTop });
          }, 20);
        } else {
          window.scrollTo({ top: targetTop });
        }
      }
    });
  
    $(window).on('load scroll', function () {
      if (!$('.eNavWrap').length || isFromClick) return;

      const headerHeight = $('#header').outerHeight() || 0;
      const navHeight = $('.eNavWrap').outerHeight() || 0;
      const fixHeight = headerHeight + navHeight;
      const winTop = $(window).scrollTop();
      const eNavTop = $('.eNavArea').offset().top - navHeight;

      let activeIndex = 0;

      for (let i = sections.length - 1; i >= 0; i--) {
        if (winTop > sections[i].offset().top - fixHeight) {
          activeIndex = i;
          break;
        }
      }

      if (winTop > eNavTop) {
        $('.eNavWrap').addClass('fixed');
      } else {
        $('.eNavWrap').removeClass('fixed');
      }
  
      const $activeTab = $tabs.eq(activeIndex);
      $activeTab.addClass('on').siblings().removeClass('on');
    });
  })();

  //Tab Scroll 슬라이드 탭인경우
  /*
  var eNavSlide = new Swiper("#eNav_swiper_slide1", {
    slidesPerView:'auto',
    grabCursor:true,
    centeredSlides:false,
  });
  
  (function () {
    const $tabs = $('.eNavWrap li');
    const tabCount = $('.eNavWrap li').length;
    const sections = [...Array(tabCount)].map((_, i) => $('#eCon' + (i + 1)));
    const isMobile = () => $(window).width() <= 750;

    let isFromClick = false;
    let clickTimeout;

    $('#eNav_swiper_slide1 a').on('click', function (e) {
      e.preventDefault();
      const $li = $(this).closest('li');
      const index = $li.index();

      clearTimeout(clickTimeout);
      isFromClick = true;
      clickTimeout = setTimeout(() => { isFromClick = false; }, 600);

      $li.addClass('on').siblings().removeClass('on');
      eNavSlide.slideTo(index);
      $('.eNavWrap').addClass('fixed');

      const headerHeight = $('#header').outerHeight() || 0;
      const navHeight = $('.eNavWrap').outerHeight() || 0;
      const fixHeight = headerHeight + navHeight;
      const targetSection = $('#eCon' + (index + 1));

      if (targetSection.length) {
        const targetTop = targetSection.offset().top - fixHeight + 50;
    
        if (window.scrollY === 0) {
          $('.eNavWrap').addClass('fixed');
    
          window.scrollTo({ top: 1 });
          setTimeout(() => {
            window.scrollTo({ top: targetTop });
          }, 20);
        } else {
          window.scrollTo({ top: targetTop });
        }
      }

      if (isMobile()) {
        const container = eNavSlide.el;
        const containerWidth = $(container).width();
        const wrapper = $(container).find('.swiper-wrapper');
        const slideOffset = $li.position().left;
        const slideWidth = $li.outerWidth(true);
        const totalSlides = $tabs.length;
        let scrollX = 0;

        if (index <= 1) {
          scrollX = 0;
        } else if (index >= 2 && index <= 5) {
          scrollX = slideOffset - (containerWidth / 2) + (slideWidth / 2);
        } else {
          const $last = $tabs.last();
          const lastOffset = $last.position().left;
          const lastWidth = $last.outerWidth(true);
          scrollX = (lastOffset + lastWidth) - containerWidth;
        }
        wrapper.css('transform', `translate3d(${-scrollX}px, 0, 0)`);
      }
    });
  
    $(window).on('load scroll', function () {
      if (!$('.eNavWrap').length || isFromClick) return;

      const headerHeight = $('#header').outerHeight() || 0;
      const navHeight = $('.eNavWrap').outerHeight() || 0;
      const fixHeight = headerHeight + navHeight;
      const winTop = $(window).scrollTop();
      const eNavTop = $('.eNavArea').offset().top - navHeight;

      let activeIndex = 0;

      for (let i = sections.length - 1; i >= 0; i--) {
        if (winTop > sections[i].offset().top - fixHeight) {
          activeIndex = i;
          break;
        }
      }

      if (winTop > eNavTop) {
        $('.eNavWrap').addClass('fixed');
      } else {
        $('.eNavWrap').removeClass('fixed');
      }
  
      const $activeTab = $tabs.eq(activeIndex);
      $activeTab.addClass('on').siblings().removeClass('on');
      eNavSlide.slideTo(activeIndex);

      if (isMobile()) {
        const container = eNavSlide.el;
        const containerWidth = $(container).width();
        const wrapper = $(container).find('.swiper-wrapper');
        const slideOffset = $activeTab.position().left;
        const slideWidth = $activeTab.outerWidth(true);
        const totalSlides = $tabs.length;
        let scrollX = 0;

        if (activeIndex <= 1) {
          scrollX = 0;
        } else if (activeIndex >= 2 && activeIndex <= 5) {
          scrollX = slideOffset - (containerWidth / 2) + (slideWidth / 2);
        } else {
          const $last = $tabs.last();
          const lastOffset = $last.position().left;
          const lastWidth = $last.outerWidth(true);
          scrollX = (lastOffset + lastWidth) - containerWidth;
        }
        wrapper.css('transform', `translate3d(${-scrollX}px, 0, 0)`);
      }
    });
  })();
  */
})